import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=4f5346b9&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"
import style0 from "./Customer.vue?vue&type=style&index=0&id=4f5346b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5346b9",
  null
  
)

export default component.exports